import get from 'lodash.get';

const getters = {
  hasAccessTo: state => feature => {
    return Boolean(get(state.features, feature));
  },

  defaultRoute: state => {
    return state.features.default;
  },

  hasAccessToAllClasses: state => {
    return Boolean(state.features.all_classes);
  },

  hasAccessToSchedule: state => {
    return Boolean(state.features.my_schedule);
  },

  canUseFeature: state => feature => {
    return state.featuresAvailable.includes(feature);
  },
};

export default getters;
